export default __webpack_public_path__ + "static/media/home3.c00a4f74.png";